import React from "react";
import img from "../../assets/team/team3.png";
function Paul() {
  return (
    <div className="bg-[#E8FCFF] w-full flex justify-center items-center py-11">
      <div className="max-w-[1440px] flex justify-between flex-col lg:flex-row items-center px-10 w-full gap-10">
        <div className="flex justify-center flex-col items-start gap-4">
          <h1 className="font-bold text-lightGreen-500 text-3xl md:text-5xl">
            Paul Stephany
          </h1>
          <h2 className="font-bold text-lightGreen-500 text-xl md:text-2xl">
            MFT, BCBA
          </h2>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            Paul Stephany is a Licensed Marriage and Family Therapist and a
            Board Certified Behavior Analyst.
          </p>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            He has over <span className="font-mono">25</span> years experience
            working with children with autism, developmental disabilities and
            severe behavior problems in the United States and Europe.
          </p>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            He has developed many comprehensive training programs for parents on
            applied behavior analysis and evidence-based practice in autism
            treatment.
          </p>
          {/* <p className="font-normal text-lightGreen-500 text-lg lg:max-w-[680px]">
            Paul is also a Senior Lecturer at the University of Social Sciences
            and Humanities in Warsaw.
          </p> */}
        </div>
        <img src={img} alt="" />
      </div>
    </div>
  );
}

export default Paul;
